/* tslint:disable */
/* eslint-disable */
/**
 * K2B
 * The K2B API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CreateSoilPointPollutantDto } from '../models';
import { SoilPointPollutant } from '../models';
import { UpdateSoilPointPollutantDto } from '../models';
import { getFromStorage } from '../../app/helpers';
/**
 * SoilPointPollutantsApi - axios parameter creator
 * @export
 */
export const SoilPointPollutantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateSoilPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        soilPointPollutantsControllerCreate: async (body: CreateSoilPointPollutantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling soilPointPollutantsControllerCreate.');
            }
            const localVarPath = `/soil-point-pollutants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers || {})["Content-Type"] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        soilPointPollutantsControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/soil-point-pollutants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        soilPointPollutantsControllerFindByPointId: async (pointId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pointId' is not null or undefined
            if (pointId === null || pointId === undefined) {
                throw new RequiredError('pointId','Required parameter pointId was null or undefined when calling soilPointPollutantsControllerFindByPointId.');
            }
            const localVarPath = `/soil-point-pollutants/point/{pointId}`
                .replace(`{${"pointId"}}`, encodeURIComponent(String(pointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        soilPointPollutantsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling soilPointPollutantsControllerFindOne.');
            }
            const localVarPath = `/soil-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        soilPointPollutantsControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling soilPointPollutantsControllerRemove.');
            }
            const localVarPath = `/soil-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSoilPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        soilPointPollutantsControllerUpdate: async (body: UpdateSoilPointPollutantDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling soilPointPollutantsControllerUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling soilPointPollutantsControllerUpdate.');
            }
            const localVarPath = `/soil-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers || {})["Content-Type"] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SoilPointPollutantsApi - functional programming interface
 * @export
 */
export const SoilPointPollutantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateSoilPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerCreate(body: CreateSoilPointPollutantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<SoilPointPollutant>>> {
            const localVarAxiosArgs = await SoilPointPollutantsApiAxiosParamCreator(configuration).soilPointPollutantsControllerCreate(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<SoilPointPollutant>>>> {
            const localVarAxiosArgs = await SoilPointPollutantsApiAxiosParamCreator(configuration).soilPointPollutantsControllerFindAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<SoilPointPollutant>>>> {
            const localVarAxiosArgs = await SoilPointPollutantsApiAxiosParamCreator(configuration).soilPointPollutantsControllerFindByPointId(pointId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<SoilPointPollutant>>> {
            const localVarAxiosArgs = await SoilPointPollutantsApiAxiosParamCreator(configuration).soilPointPollutantsControllerFindOne(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<SoilPointPollutant>>> {
            const localVarAxiosArgs = await SoilPointPollutantsApiAxiosParamCreator(configuration).soilPointPollutantsControllerRemove(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {UpdateSoilPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerUpdate(body: UpdateSoilPointPollutantDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<SoilPointPollutant>>> {
            const localVarAxiosArgs = await SoilPointPollutantsApiAxiosParamCreator(configuration).soilPointPollutantsControllerUpdate(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SoilPointPollutantsApi - factory interface
 * @export
 */
export const SoilPointPollutantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {CreateSoilPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerCreate(body: CreateSoilPointPollutantDto, options?: AxiosRequestConfig): Promise<AxiosResponse<SoilPointPollutant>> {
            return SoilPointPollutantsApiFp(configuration).soilPointPollutantsControllerCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerFindAll(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<SoilPointPollutant>>> {
            return SoilPointPollutantsApiFp(configuration).soilPointPollutantsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<SoilPointPollutant>>> {
            return SoilPointPollutantsApiFp(configuration).soilPointPollutantsControllerFindByPointId(pointId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<SoilPointPollutant>> {
            return SoilPointPollutantsApiFp(configuration).soilPointPollutantsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<SoilPointPollutant>> {
            return SoilPointPollutantsApiFp(configuration).soilPointPollutantsControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSoilPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilPointPollutantsControllerUpdate(body: UpdateSoilPointPollutantDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<SoilPointPollutant>> {
            return SoilPointPollutantsApiFp(configuration).soilPointPollutantsControllerUpdate(body, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SoilPointPollutantsApi - object-oriented interface
 * @export
 * @class SoilPointPollutantsApi
 * @extends {BaseAPI}
 */
export class SoilPointPollutantsApi extends BaseAPI {
    /**
     * 
     * @param {CreateSoilPointPollutantDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoilPointPollutantsApi
     */
    public async soilPointPollutantsControllerCreate(body: CreateSoilPointPollutantDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<SoilPointPollutant>> {
        return SoilPointPollutantsApiFp(this.configuration).soilPointPollutantsControllerCreate(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoilPointPollutantsApi
     */
    public async soilPointPollutantsControllerFindAll(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<SoilPointPollutant>>> {
        return SoilPointPollutantsApiFp(this.configuration).soilPointPollutantsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} pointId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoilPointPollutantsApi
     */
    public async soilPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<SoilPointPollutant>>> {
        return SoilPointPollutantsApiFp(this.configuration).soilPointPollutantsControllerFindByPointId(pointId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoilPointPollutantsApi
     */
    public async soilPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<SoilPointPollutant>> {
        return SoilPointPollutantsApiFp(this.configuration).soilPointPollutantsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoilPointPollutantsApi
     */
    public async soilPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<SoilPointPollutant>> {
        return SoilPointPollutantsApiFp(this.configuration).soilPointPollutantsControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {UpdateSoilPointPollutantDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoilPointPollutantsApi
     */
    public async soilPointPollutantsControllerUpdate(body: UpdateSoilPointPollutantDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<SoilPointPollutant>> {
        return SoilPointPollutantsApiFp(this.configuration).soilPointPollutantsControllerUpdate(body, id, options).then((request) => request(this.axios, this.basePath));
    }
}
